<script>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

export default {
  name: 'Modal',
  inheritAttrs: false,
  emits: ['confirm', 'cancel', 'addRosterSpell', 'removeRosterSpell', 'addRosterEquipment', 'removeRosterEquipment'],
  setup() {
    const i18n = useI18n();
    const bgLoaded = ref(false);
    const needsBlur = ref(false);
    const bgRef = ref(null);

    const onBgLoad = () => {
      bgLoaded.value = true;
    };

    onMounted(() => {
      if (bgRef.value?.complete) {
        bgLoaded.value = true;
      } else {
        needsBlur.value = true;
      }
    });

    return {
      t: i18n.t,
      bgLoaded,
      needsBlur,
      bgRef,
      onBgLoad
    };
  }
}
</script>

<template>
  <vue-final-modal v-slot="{ params, close }" v-bind="$attrs" classes="modal-container" content-class="modal-content">
    <span class="modal__title">
      <slot name="title"></slot>
      <div class="modal__action">
        <button @click="$emit('confirm', close)" class="button button_dark">{{ t('modal.save') }}</button>
        <button @click="$emit('cancel', close)" class="button button_icon">
          <img src="@/images/img/close_cards.png" alt="">
        </button>
      </div>
    </span>
    <div class="modal__content">
      <slot :params="params"></slot>
    </div>
    <img
      ref="bgRef"
      class="modal-bg"
      :class="{ 'img-blur-until-loaded': needsBlur, loaded: bgLoaded }"
      src="@/images/img/bg.webp"
      srcset="@/images/img/bg-640.webp 640w, @/images/img/bg-1024.webp 1024w, @/images/img/bg-1920.webp 1920w"
      sizes="(max-width: 640px) 100vw, (max-width: 1024px) 90vw, 800px"
      alt=""
      aria-hidden="true"
      decoding="async"
      fetchpriority="low"
      @load="onBgLoad"
    >
  </vue-final-modal>
</template>

<style scoped>
::v-deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep(.modal-content) {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 100%;
  margin: 0;
  background: #fff;
  background-color: var(--dark-base);

  .modal-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }
}
.modal__title {
  position: relative;
  z-index: 1;
  margin: 0;
  background: var(--light-base);
  display: flex;
  justify-content: space-between;
}
.modal__title > div {
  color: var(--medium-base);
  font-size: 25px;
  text-transform: uppercase;
}
.modal__content {
  position: relative;
  z-index: 1;
  flex-grow: 1;
  overflow-y: auto;
}
.modal__action {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}
.modal__close {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}
</style>

<style scoped>
.dark-mode div ::v-deep(.modal-content) {
  border-color: #2d3748;
  background-color: #1a202c;
}
</style>
